import { useState, useEffect, memo } from 'react';
import { useAuth } from "../../context/loginContext.js";
import { Link } from 'react-router-dom';
import { ButtonToolbar, OverlayTrigger, Popover } from "react-bootstrap";
import RoLinkFav from "./row_fv.js";


const Home = () => {

    //contexto de sesion
    const { get_favoritos, favoritos, Loadfavoritos } = useAuth();
    const [row_fav, setRowFav] = useState([]);

    const popoverHoverFocus = (texto) => {
        return (
            <Popover className="p-2" id="popover-trigger-hover-focus" title="Popover bottom">
                {texto}
            </Popover>
        );
    }

    const fovoritos_get = async () => {
        var fav_result = await get_favoritos();

        var array_fav = [];

        fav_result.forEach(fv => {
            console.log(fv)
            array_fav.push(<RoLinkFav fv={fv} key={"fv-" + fv.uuid_tablero}/>);
            /*
            array_fav.push(
                //

                <div className='list-group-item' key={"fv-" + fv.titulo_tablero}>
                    <Link  to={("/tablero?tbl=" + fv.uuid_gtableros + "|" + fv.uuid_tablero)} type="button" className='tdec-none' > {fv.titulo_tablero} <i className="bi bi-box-arrow-up-right"></i></Link>
                    <div className='popover_mo me-1'>
                        <i className="bi bi-trash3-fill"></i>
                    </div>
                    <div className='popover_mo me-4_5'>

                        <ButtonToolbar>
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="top"
                                overlay={popoverHoverFocus(fv.notas)}
                            >
                                <i className="bi bi-info-circle"></i>
                            </OverlayTrigger>
                        </ButtonToolbar>
                    </div>
                </div>
            );
            */
        });

        setRowFav(array_fav);
    }


    



    useEffect(() => {

        fovoritos_get();

        window.addEventListener("blur", (event) => {
           //console.log("salio de la pagina");
        });
    }, [])

    //retornamos "la vista para el login"
    return (
        <div className='bg-dark-subtle h-100 pb-4'>
            <div className="card-body px-4 pt-3 pb-0">
                <div className='mb-3'>
                    <label className='text-title-001'>Home - <b className='text-body-tertiary'>Power BI </b></label>
                </div>
                
            </div>

            <div className='card-body p-3 h-100'>
            <div className='card bg-body-secondary p-3'>
                    <p>
                        Bienvenido al panel principal de Power BI. Aquí encontrará una visión general de los indicadores clave de rendimiento <Link to={"https://asana.com/es/resources/key-performance-indicator-kpi"} target='_blank'>(KPIs)</Link> y las principales tendencias de AUTOCOM-BI. Utilice las diferentes pestañas y filtros para explorar la información detalladamente.
                    </p>
                </div>
                <div className='row pt-3 g-3'>
                    <div className='col-md-6 '>
                        <div className='card bg-body-secondary p-3 '>
                            <label className='text-title-001 fs-6'>Favoritos <b className='text-body-tertiary'><i className="bi bi-star-fill"></i></b></label>
                            <p className='mt-2'>Tus tableros favoritos, listos para ti aquí.</p>

                            {
                                Loadfavoritos ?
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <img src="./img/progress-unscreen.gif" width={"80px"} />
                                    </div>
                                    :
                                    favoritos.length !== 0 ?
                                        <div className="list-group">
                                            {row_fav}
                                        </div>
                                        :
                                        <>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                <img src="./img/darse-de-baja.png" width={"80px"} />
                                            </div>
                                            <label className='text-title-001 fs-6 w-100 text-center'><b className='text-body-tertiary'>Por el momento, no has añadido ningún elemento</b></label>
                                        </>
                            }

                        </div>
                    </div>
                    <div className='col-md-6 '>
                        <div className='card bg-body-secondary p-3 d-flex justify-content-center align-items-center'>
                            <img src="./img/presentation-bro.svg" className="w-50" />
                        </div>
                    </div>
                </div>
            </div>
        </div >



    );
}

export default memo(Home);

